import React from "react";
import { StyledLink } from "../../../styled-mui/link/styled-link";
import { StyledTypography } from "../../../styled-mui/typography/styled-typography";
import { EXTERNAL_LINK, LINK_USAGE } from "../../../constants/marketing";
import { useSelector } from "react-redux";
import { GetStaticLinksSelector } from "../../../redux/selectors/category";
import AsyncCall from "../../../_foundation/gtm/async.service";
import { CLICK } from "../../../_foundation/constants/gtm";
import { ImageLayout } from "../../elements/image";
import storeUtil from "../../../utils/storeUtil";
import { Box, Divider } from "@mui/material";
import { palette } from "../../../themes/color-palette";

interface HeaderNavigationWidgetProps {
  productNav?: any;
  callCloseMegaMenu?: () => void;
}

const proLinkMobileImgStyles: React.CSSProperties = {
  margin: "0px 2px 0px 0px",
  position: "relative",
  top: "-2px",
  maxHeight: "20px",
  maxWidth: "15px",
};

const HeaderNavigationWidget: React.FC<HeaderNavigationWidgetProps> = ({ productNav, callCloseMegaMenu }) => {
  const staticLinksRedux: any = useSelector(GetStaticLinksSelector);
  const headerLinks = staticLinksRedux?.headerLinks || [];

  const promoLinks = headerLinks?.filter((l) => l?.usage === LINK_USAGE.PROMO) || [];
  const eventLinks = headerLinks?.filter((l) => l?.usage === LINK_USAGE.EVENT) || [];
  const standardLinks = headerLinks?.filter((l) => l?.usage === LINK_USAGE.STANDARD) || [];
  const proLink = headerLinks?.filter((l) => l?.usage === LINK_USAGE.PROLINK) || [];

  return (
    <>
      {/* ADD LINK PROMOTIONS */}
      {promoLinks.map((link, index) => (
        <StyledLink
          key={index}
          to={link.seo?.url}
          onClick={() => {
            AsyncCall.sendClick(CLICK.NAV, { navlink: link.seo?.url });
            if (callCloseMegaMenu) callCloseMegaMenu();
          }}
          href={link.seo?.type === EXTERNAL_LINK ? link.seo?.url : null}
          className="menu-mobile-link-top bg border">
          <StyledTypography variant="body1" color="primary" sx={{ textTransform: "uppercase" }}>
            {link.seo?.label}
          </StyledTypography>
        </StyledLink>
      ))}

      {/* ADD LINK EVENTS */}
      {eventLinks.map((link, index) => (
        <StyledLink
          key={index}
          to={link.seo?.url}
          onClick={() => {
            AsyncCall.sendClick(CLICK.NAV, { navlink: link.seo?.url });
            if (callCloseMegaMenu) callCloseMegaMenu();
          }}
          href={link.seo?.type === EXTERNAL_LINK ? link.seo?.url : null}
          className="menu-mobile-link-top">
          <StyledTypography variant="body1" color="secondary" sx={{ textTransform: "uppercase" }}>
            {link.seo?.label}
          </StyledTypography>
        </StyledLink>
      ))}

      {/* ADD LINK TOP CATEGORIES */}
      {productNav}

      {/* ADD LINK STANDARD */}
      {standardLinks.map((link, index) => (
        <StyledLink
          key={index}
          to={link.seo?.url}
          onClick={() => {
            AsyncCall.sendClick(CLICK.NAV, { navlink: link.seo?.url });
            if (callCloseMegaMenu) callCloseMegaMenu();
          }}
          href={link.seo?.type === EXTERNAL_LINK ? link.seo?.url : null}
          className="menu-mobile-link-top">
          <StyledTypography variant="body1" sx={{ textTransform: "uppercase" }}>
            {link.seo?.label}
          </StyledTypography>
        </StyledLink>
      ))}

      {proLink.map((link: Record<string, any>) => (
        <>
          <Box className="divider-container" px="20px" my="10px">
            <Divider sx={{ borderColor: palette.gray.neutralGray300 }} />
          </Box>
          <StyledLink
            key={link.seo?.label}
            to={link.seo?.url}
            onClick={() => {
              AsyncCall.sendClick(CLICK.NAV, { navlink: link.seo?.url });
              if (callCloseMegaMenu) callCloseMegaMenu();
            }}
            href={link.seo?.type === EXTERNAL_LINK ? link.seo?.url : null}
            className="menu-mobile-link-top">
            <ImageLayout styles={proLinkMobileImgStyles} src={storeUtil.getUrlPicture(link.seo?.mobileImg, "")} />
            <StyledTypography variant="body1" sx={{ textTransform: "uppercase" }} color="primary">
              {link.seo?.label}
            </StyledTypography>
          </StyledLink>
        </>
      ))}
    </>
  );
};

export default HeaderNavigationWidget;
